import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const CarMagnets = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for car magnets?", 
            answer: "Printingy offers extensive customisation options for the Printing Car Magnets, including sizes, shapes, colours, and finishes. Our Custom Car Magnets Printing services allow you to include logos, contact information, and vibrant graphics that align with your branding. Additional options like UV protection and waterproof materials ensure long-lasting durability."
        },
        { 
            question: "Does Printingy handle bulk orders for car magnets?", 
            answer: "Yes, Printingy specialises in bulk Printing of Car Magnets, catering to businesses, event organisers, and fleet managers with large-scale needs. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for promotional campaigns or branded fleets."
        },
        { 
            question: "What industries benefit from custom car magnet printing services?", 
            answer: "Custom car magnet printing services are widely used in retail, delivery services, real estate, and event management industries. Businesses rely on Signs and custom Magnet Printing for mobile advertising, while organisations use magnetic sticker printing for cars for temporary signage or promotional purposes. Printingy provides tailored solutions to meet the unique needs of each sector."
        },
        { 
            question: "What materials are used for custom car magnets?", 
            answer: "We use high-quality materials for Custom Car magnet printing, including durable magnetic sheets and eco-friendly options. These materials are designed to withstand weather conditions, UV exposure, and frequent handling. Finishes such as matte or glossy add to your car magnets' professional appearance and longevity."
        },
        { 
            question: "Does Printingy provide design assistance for car magnets?", 
            answer: "Yes, our Custom Car Magnets Printing services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From font selection to graphic placement, we ensure your car magnets align with your branding."
        },
        { 
            question: "What is the typical turnaround time for car magnet printing?", 
            answer: "Turnaround times for Printing of Car Magnets depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for car magnet printing?", 
            answer: "Yes, Printingy is committed to sustainability and offers eco-friendly options for car magnetic sticker printing. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses seeking environmentally responsible solutions."
        },
        { 
            question: "What factors should I consider when ordering car magnets?", 
            answer: "When ordering Custom Magnet Printing, consider the magnets' size, design, and placement. Choosing the right material and finish ensures your car magnets are effective, durable, and visually appealing. Printingy’s team guides the process to help you achieve the best results."
        },
        { 
            question: "How do I place an order for car magnet printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for Custom Car Magnets Printing, including customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk car magnet printing cost-effective?", 
            answer: "Bulk car magnet printing reduces per-unit costs, making it an economical choice for large-scale projects. By consolidating materials and streamlining production, Printingy delivers high-quality results at competitive prices. Our bulk Printing of Car Magnets services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Custom Car Magnets');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Car Magnets Printing Services"
  description="Professional printing of car magnets for advertising. Bulk custom car magnet printing and magnetic sticker printing for cars with durable designs."
  keywords="Bulk post-it printing,
Custom sticky notes print,
Post-it Notes,
Printing Sticky Notes Pad,
Post-it Notes Printing,
Custom Post-it notes printing,
Personalised sticky notes printing
"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Car Magnets Printing Services</h1>
              <h2 className="text-muted">
              Professional signs and magnetic sticker printing for cars
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Car magnets are an effective and versatile tool for mobile advertising, offering businesses a cost-effective way to promote their brand on the go. Printingy specialises in Printing Car Magnets, including Custom Car Magnets Printing and magnetic sticker printing for cars, tailored to your needs.</p>
          <p>Our durable car magnets are designed to withstand various weather conditions while maintaining vibrant colours and sharp graphics. Whether for company vehicles or promotional campaigns, our Signs and custom Magnet Printing services ensure professional and impactful designs.</p>
          <p>With options for bulk orders and customisation, Printingy guarantees high-quality and cost-effective solutions for all your car magnet needs. Trust us to create magnetic signage that elevates your brand visibility.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Car Magnet Printing Solutions</h2>
                <h3 className="large-hed">High-quality, affordable, and customisable magnetic stickers for cars </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Custom Car Magnets Printing for mobile advertising.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Printing of Car Magnets for cost-effective branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials resistant to weather, fading, and wear.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant colours and sharp details for professional appeal.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for precision and consistency.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and non-toxic inks for sustainable solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, event organisers, and fleet owners nationwide
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/carmagnets.jpg" // Path relative to the public folder
                  alt="Custom Post-it Notes printing services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Car Magnets Delivered On Time</h2>
            <h3 className="small-hed">Focus on your promotions while we handle your car magnet printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional Custom Magnet Printing services. Whether you need magnetic stickers printed for cars for a fleet or bulk Signs and custom Magnets Printed for promotional campaigns, we ensure consistent quality and timely delivery.</p>
            <p>Our streamlined processes and commitment to excellence guarantee that your car magnets will be professional, durable, and impactful. Partner with Printingy for reliable car magnet solutions that drive your brand forward.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default CarMagnets;
